export const transactionColumnListing = [
  {
    label: '',
    value: 'transactionTypeSvg',
    handleBarKey: `
    {{#if  transactionType }}
      <div class="svg-outline bg-primary-muted primaryColor is-center" style="width:32px; height:32px;">
      {{#if (eq transactionType "debit")}}
      {{{ svgIcon 'debit' '32px' '32px' }}}
      {{/if}}
      {{#if (eq transactionType "credit")}}
      {{{ svgIcon 'credit' '32px' '32px' }}}
      {{/if}}
      </div>
    {{/if}}`,
    selected: true,
  },
  {
    label: ' Description ',
    value: 'description',
    handleBarKey: '{{ description }}',
    selected: true,
  },
  {
    label: 'Currency',
    value: 'currency',
    handleBarKey: '{{ currency }}',
    selected: true,
  },
  {
    label: ' Reference ID ',
    value: 'referenceID',
    handleBarKey: '{{ transactionNumber }}',
    selected: true,
  },
  {
    label: ' Amount ',
    value: 'amount',
    handleBarKey: `{{#if (eq transactionType "credit")}}+{{else}}-{{/if}}{{currencyPipe amount currencyCode=currency}}`,
    selected: true,
  },
];

export const exchangeTransactionColumnListing = [
  {
    label: 'Date',
    value: 'date',
    handleBarKey: '{{ transactionDate }}',
    selected: true,
  },
  {
    label: 'From Currency',
    value: 'from-currency',
    handleBarKey: '{{ buyCurrency }}',
    selected: true,
  },
  {
    label: 'To Currency',
    value: 'to-currency',
    handleBarKey: '{{ sellCurrency }}',
    selected: true,
  },
  {
    label: 'Amount Exchanged',
    value: 'amount-exchanged',
    handleBarKey: `{{ sellAmount }}`,
    selected: true,
  },
  {
    label: 'Amount Received',
    value: 'amount-received ',
    handleBarKey: `{{ buyAmount }}`,
    selected: true,
  },
  {
    label: 'Status',
    value: 'status ',
    handleBarKey: `<span class="text-capitalize">{{ status }}</span>`,
    selected: true,
  },
  {
    label: 'Transaction ID',
    value: 'transaction-id',
    handleBarKey: `{{ transactionNumber }}`,
    selected: true,
  },
  {
    label: '',
    value: 'more-option',
    handleBarKey: `<span id="more-options">{{{ svgIcon 'more-options-eclipse' '32px' '32px' }}}</span>`,
    selected: true,
  },
];

export const cardTransactionColumnListing = [
  {
    label: 'Name / Business',
    value: 'name-business',
    handleBarKey: '{{ merchant.name }}',
    selected: true,
  },
  {
    label: 'Type',
    value: 'type',
    handleBarKey: `<span class="text-capitalize">{{type}}</span>`,
    selected: true,
  },
  {
    label: 'Reference ID ',
    value: 'referenceID',
    handleBarKey: '{{ transactionNumber }}',
    selected: true,
  },
  {
    label: 'Status',
    value: 'status',
    handleBarKey: '<span class="text-capitalize">{{ status }}</span>',
    selected: true,
  },
  {
    label: 'Transaction Type',
    value: 'transactionType',
    handleBarKey: '<span class="text-capitalize">Virtual Debit</span>',
    selected: true,
  },
  {
    label: 'Amount',
    value: 'amount',
    handleBarKey: `{{ currencyPipe totalAmount currencyCode=transactionCurrency display='symbol-narrow' }}`,
    selected: true,
  },
];

export const pendingWithdrawalColumnListing = [
  {
    label: 'Payment reference',
    value: 'payment-ref',
    handleBarKey: '{{ data.paymentReference }}',
    selected: true,
  },
  {
    label: 'Amount',
    value: 'amount',
    handleBarKey: `{{ currencyPipe data.amount currencyCode=data.currency display='symbol-narrow' }}`,
    selected: true,
  },
  {
    label: 'Withdrawal Date',
    value: 'withdrawal-date',
    handleBarKey: `{{ datePipe data.schedulePaymentDate format='dd-MM-yyyy' }}`,
    selected: true,
  },
];

export const scheduledPaymentColumnListing = [
  {
    label: 'Beneficiary name',
    value: 'beneficiary-name',
    handleBarKey: '{{ data.name }}',
    selected: true,
  },
  {
    label: 'Amount',
    value: 'amount',
    handleBarKey: `{{ currencyPipe data.amount currencyCode=data.currency display='symbol-narrow' }}`,
    selected: true,
  },
  {
    label: 'Scheduled Date',
    value: 'scheduled-date',
    handleBarKey: `{{ datePipe data.schedulePaymentDate format='dd-MM-yyyy' }}`,
    selected: true,
  },
];
